/**
 * How a task repeats. Mirrors tasks.repeat_every in MySQL.
 *
 * Repeat is ON COMPLETION: marking the task DONE is what creates the next
 * occurrence, with the due date (and reminder) shifted by one interval. An
 * abandoned task therefore does not multiply - nothing new appears until
 * somebody finishes the current one.
 */
export const TaskRepeat = {
    NONE: 'NONE',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
};
export const TASK_REPEAT_LABEL = {
    NONE: 'Does not repeat',
    DAILY: 'Daily',
    WEEKLY: 'Weekly',
    MONTHLY: 'Monthly',
};
export const TASK_REPEATS = Object.values(TaskRepeat);
export const TITLE_MAX = 500;
export const DETAILS_MAX = 5000;
export const BLOCKED_REASON_MAX = 500;
export const COMMENT_MAX = 2000;
/**
 * Display form of a task key: every number zero-padded to three digits.
 *   CG-8    -> CG-008
 *   CG-8-1  -> CG-008-001
 * Formatting only - the stored key stays short, so links, logs, and old data
 * all keep working.
 */
export function formatTaskKey(key) {
    return key.replace(/\d+/g, (n) => n.padStart(3, '0'));
}
//# sourceMappingURL=tasks.js.map